module.exports = __webpack_public_path__ + "static/media/kidbanner.de77853a.png";